<template>
  <div class="qcode-sign-container">
    <!-- 签到成功 -->
    <div v-if="signSuccess" class="sign-success">
      <div class="sign-success-icon"></div>
      <!-- 签到成功 -->
      <div class="sign-success-title">{{ $t('signin_succ') }}</div>
      <!-- 签到时间 -->
      <div class="sign_time">
        {{ $t('signin_time') }}：<span>{{ signInTime }}</span>
      </div>
    </div>

    <!-- 签到已结束 -->
    <div v-else-if="signLate" class="sign-late">
      <div class="sign-late-icon"></div>
      <div class="sign-late-title">{{ $t('checkin_ended') }}</div>
    </div>

    <!-- 暂无扫码权限 -->
    <div v-else-if="noAccess" class="no-access">
      <div class="no-access-icon"></div>
      <div class="no-access-title">{{ $t('no_scan_permission') }}</div>
    </div>

    <!-- 错误页面 -->
    <div v-else-if="showError" class="error-page">
      <div class="error-icon"></div>
      <div class="error-title">{{ errorMessage }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getTrainingSignScan } from '@/api/requests/TrainingRequests'
import { showToast } from 'vant'
import { useI18n } from 'vue-i18n'

const route = useRoute()
const router = useRouter()
const { t } = useI18n()

// 响应式数据
const errorMessage = ref('')
const noAccess = ref(false)
const showError = ref(false)
const signSuccess = ref(false)
const signInTime = ref('')
const signLate = ref(false)

interface SignInParams {
  signInId: string | null
  qrcode: string | null
}

// 初始化函数
const init = async (): Promise<void> => {
  try {
    const jumpId = route.query.jumpId as string | null
    const qrcode = route.query.qrcode as string | null

    const params: SignInParams = {
      signInId: jumpId,
      qrcode
    }

    const { code, data, msg } = await getTrainingSignScan(params)

    if (code === 1) {
      const signInStatus = data.signInRecord.signInStatus

      if (signInStatus === 200) {
        // 显示签到成功页面
        signInTime.value = data.signInRecord.signInTime
        signSuccess.value = true
      } else if (signInStatus === 300) {
        // 显示签到已结束页面
        signLate.value = true
      }
    } else if (code === 4001542 || code === 4001543) {
      // 无权限
      noAccess.value = true
    } else if (code === 14280) {
      showToast(msg)
      localStorage.removeItem('sandsTalkToken')
    } else {
      // 其他错误 - 显示错误页面
      errorMessage.value = msg || ''
      showError.value = true
    }
  } catch (error) {
    console.error('签到请求失败:', error)
    errorMessage.value = t('app_network_error')
    showError.value = true
  }
}

onMounted(() => {
  const sandsTalkToken = localStorage.getItem('sandsTalkToken')
  if (!sandsTalkToken) {
    const currentUrl = encodeURIComponent(window.location.href)
    router.push({
      path: '/enterpriseLogin',
      query: {
        redirect: currentUrl
      }
    })
  } else {
    init()
  }
})
</script>

<style scoped>
.qcode-sign-container {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 签到成功样式 */
.sign-success {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  font-size: 14px;
}

.sign-success-icon {
  margin-top: 50%;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url('@/assets/images/unsupported/success.png');
}

.sign-success-title {
  font-size: 21px;
  font-weight: 500;
  text-align: center;
  color: #171921;
  margin-top: 10px;
}

.sign_time {
  font-size: 16px;
  font-weight: 400;
  text-align: center;
  color: #999999;
  margin-top: 22px;
}

/* 签到已结束样式 */
.sign-late {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  font-size: 14px;
}

.sign-late-icon {
  margin-top: 50%;
  width: 180px;
  height: 180px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url('@/assets/images/empty/no_permission.png');
}

.sign-late-title {
  margin-top: 8px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #999999;
  line-height: 20px;
}

/* 暂无权限样式 */
.no-access {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100vh;
  font-size: 14px;
}

.no-access-icon {
  width: 180px;
  height: 180px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url('@/assets/images/empty/no_permission.png');
}

.no-access-title {
  margin-top: 8px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #999999;
  line-height: 20px;
}

/* 错误页面样式 */
.error-page {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100vh;
  font-size: 14px;
}

.error-icon {
  width: 180px;
  height: 180px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url('@/assets/images/empty/no_permission.png');
}

.error-title {
  margin-top: 8px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #999999;
  line-height: 20px;
}
</style>
